import { useTranslate } from '@ur-solutions/react-hooks'

export type GenerationRuleKind = 'diet' | 'salary_day' | 'both'
export type GenerationRuleCalculation =
  | 'per_work_period'
  | 'six_hour_quarter'
  | 'eight_hour_third'
export type GenerationRuleRestHandling = 'break' | 'continue'
export type GenerationRuleRounding = 'floor' | 'ceil'
export type GenerationModifierSubject = 'work_period' | 'rest' | 'both'
export type GenerationModifierMatchMode =
  | 'starts_in'
  | 'ends_in'
  | 'starts_or_ends_in'
  | 'starts_and_ends_in'
export type GenerationModifierLocationTest = 'inside' | 'outside'
export type GenerationModifierAward = 'award' | 'deny'
export type GenerationModifierChainAction = 'break' | 'continue'
export type RestType = 'daily' | 'reduced_weekly' | 'weekly'

export const CHAIN_CALCULATIONS: GenerationRuleCalculation[] = [
  'six_hour_quarter',
  'eight_hour_third',
]

export function useGenerationRuleLabels() {
  return useTranslate({
    kind: {
      diet: 'settings.generation-rules.kind-diet',
      salary_day: 'settings.generation-rules.kind-salary-day',
      both: 'settings.generation-rules.kind-both',
    },
    rule: {
      per_work_period: 'settings.generation-rules.rule-per-work-period',
      six_hour_quarter: 'settings.generation-rules.rule-six-hour',
      eight_hour_third: 'settings.generation-rules.rule-eight-hour',
    },
    restHandling: {
      break: 'settings.generation-rules.rest-handling-break',
      continue: 'settings.generation-rules.rest-handling-continue',
    },
    rounding: {
      floor: 'settings.generation-rules.rounding-floor',
      ceil: 'settings.generation-rules.rounding-ceil',
    },
    subject: {
      work_period: 'settings.generation-modifiers.subject-work-period',
      rest: 'settings.generation-modifiers.subject-rest',
      both: 'settings.generation-modifiers.subject-both',
    },
    matchMode: {
      starts_in: 'settings.generation-modifiers.match-starts-in',
      ends_in: 'settings.generation-modifiers.match-ends-in',
      starts_or_ends_in:
        'settings.generation-modifiers.match-starts-or-ends-in',
      starts_and_ends_in:
        'settings.generation-modifiers.match-starts-and-ends-in',
    },
    locationTest: {
      inside: 'settings.generation-modifiers.location-inside',
      outside: 'settings.generation-modifiers.location-outside',
    },
    award: {
      award: 'settings.generation-modifiers.award-award',
      deny: 'settings.generation-modifiers.award-deny',
    },
    chainAction: {
      break: 'settings.generation-modifiers.chain-break',
      continue: 'settings.generation-modifiers.chain-continue',
    },
    restType: {
      daily: 'settings.generation-modifiers.rest-type-daily',
      reduced_weekly: 'settings.generation-modifiers.rest-type-reduced-weekly',
      weekly: 'settings.generation-modifiers.rest-type-weekly',
    },
  })
}
